<div class="my-2 p-2" *ngIf="images$ | async; let images">
  <market-carousel-wrapper [options]="options">
    <li class="splide__slide" *ngFor="let item of images">
      <div class="overflow-hidden rounded-xl">
        <img [src]="item.image | image" alt="" />
      </div>
    </li>
  </market-carousel-wrapper>
</div>
